// SAT V5 Zone Routes Component
import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes, toRelativePath } from './routes';
import TeacherDetail from '../pages/UserManagement/subpages/TeacherDetail';
import PupilDetail from '../pages/UserManagement/subpages/PupilDetail';

// Lazy load pages
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Upload = lazy(() => import('../pages/Upload'));
const CurriculumImport = lazy(() => import('../pages/CurriculumPlanning/CurriculumImport'));
const CurriculumPlan = lazy(() => import('../pages/CurriculumPlanning/CurriculumPlan'));
const SchoolStructure = lazy(() => import('../pages/SchoolStructure'));
const LunchStructure = lazy(() => import('../pages/LunchStructure'));
const UserManagement = lazy(() => import('../pages/UserManagement'));
const RulesPreferences = lazy(() => import('../pages/RulesPreferences'));
const Settings = lazy(() => import('../pages/Settings'));
const Analytics = lazy(() => import('../pages/TimetableManagement/Analytics'));

// Timetable Management pages
const CreateTimetable = lazy(() => import('../pages/TimetableManagement/CreateTimetable'));
const TimetableViews = lazy(() => import('../pages/TimetableManagement/UserViews'));
const SubjectOptions = lazy(() => import('../pages/TimetableManagement/SubjectOptions'));

const NotFound = lazy(() => import('../../portal/pages/not-found'));

export function ZoneRoutes() {
  return (
    <Routes>
      {/* Redirect base to dashboard */}
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.dashboard} />} />

      {/* Main layout wrapper */}
      <Route
        element={
          <BasePortal
            sidebar
            microSystem
            showUserRole
            miniSidebar={true}
            navbar={true}
            sidebarHeader={true}
          />
        }
      >
        {/* 404 */}
        <Route
          path="*"
          element={
            <Suspense fallback={<MainLoading />}>
              <NotFound />
            </Suspense>
          }
        />

        {/* Dashboard */}
        <Route
          path={toRelativePath(routes.dashboard)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Dashboard />
            </Suspense>
          }
        />

        {/* Upload */}
        <Route
          path={toRelativePath(routes.upload)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Upload />
            </Suspense>
          }
        />

        {/* Curriculum Import */}
        <Route
          path={toRelativePath(routes.curriculumPlanning.import)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CurriculumImport />
            </Suspense>
          }
        />

        {/* Curriculum Plan */}
        <Route
          path={toRelativePath(routes.curriculumPlanning.plan)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CurriculumPlan />
            </Suspense>
          }
        />

        {/* School Structure */}
        <Route
          path={toRelativePath(routes.schoolStructure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolStructure />
            </Suspense>
          }
        />

        {/* Lunch Structure */}
        <Route
          path={toRelativePath(routes.lunchStructure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <LunchStructure />
            </Suspense>
          }
        />

        {/* User Management */}
        <Route
          path={toRelativePath(routes.userManagement)}
          element={
            <Suspense fallback={<MainLoading />}>
              <UserManagement />
            </Suspense>
          }
        />

        <Route
          path={toRelativePath(routes.teacherDetail)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TeacherDetail />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.pupilDetail)}
          element={
            <Suspense fallback={<MainLoading />}>
              <PupilDetail />
            </Suspense>
          }
        />

        {/* Rules & Preferences */}
        <Route
          path={toRelativePath(routes.rulesPreferences)}
          element={
            <Suspense fallback={<MainLoading />}>
              <RulesPreferences />
            </Suspense>
          }
        />

        {/* Timetable Management - Create Timetable */}
        <Route
          path={toRelativePath(routes.timetableManagement.createTimetable)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CreateTimetable />
            </Suspense>
          }
        />

        {/* Timetable Management - Views */}
        <Route
          path={toRelativePath(routes.timetableManagement.views)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TimetableViews />
            </Suspense>
          }
        />

        {/* Timetable Management - Subject Options */}
        <Route
          path={toRelativePath(routes.timetableManagement.subjectOptions)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SubjectOptions />
            </Suspense>
          }
        />

        {/* Settings */}
        <Route
          path={toRelativePath(routes.settings)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Settings />
            </Suspense>
          }
        />

        {/* Analytics */}
        <Route
          path={toRelativePath(routes.analytics)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Analytics />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

export default ZoneRoutes;
